import { fetchNeoToggles, fetchNeoConfigs } from '~/api/neo';

export const state = () => ({
  toggles: {},
  segmentations: {},
});

export const getters = {
  getNeoToggles: ({ toggles }) => toggles,
  getNeoSegmentations: ({ segmentations }) => segmentations,
};

export const actions = {
  async fetchNeoToggles({ commit, rootState }, toggleIds) {
    try {
      const uninitiatedToggleIds = [];
      toggleIds.forEach(toggle => {
        if (!Object.keys(rootState.neo.toggles).includes(toggle)) {
          uninitiatedToggleIds.push(toggle);
        }
      });
      if (uninitiatedToggleIds.length <= 0) return;
      const response = await fetchNeoToggles(uninitiatedToggleIds);
      const mappedToggles = {};
      const mappedSegmentation = {};
      response.data.forEach(toggle => {
        mappedToggles[toggle.id] = toggle.active;
        mappedSegmentation[toggle.id] = toggle.segmentation;
      });
      commit('setNeoToggles', { toggles: mappedToggles, segmentations: mappedSegmentation });
    } catch (error) {
      console.error('[ERROR FETCH NEO TOGGLES]', error);
    }
  },
  async fetchNeoConfigs(_, configKeys) {
    try {
      const response = await fetchNeoConfigs(configKeys);
      return response;
    } catch (error) {
      console.error('[ERROR FETCH NEO CONFIGS]', error);
      throw error;
    }
  },
};

export const mutations = {
  setNeoToggles(state, { toggles, segmentations = {} }) {
    state.toggles = { ...state.toggles, ...toggles };
    state.segmentations = { ...state.segmentations, ...segmentations };
  },
  clearNeoToggles(state) {
    state.toggles = {};
  },
};
